var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v(
          "New Select Item for " + _vm._s(_vm.$attrs["v-model"].selectItemGroup)
        ),
      ]),
      _c(
        "span",
        [
          _c("small", [_vm._v("Select")]),
          _c("el-input", {
            attrs: { disabled: "", placeholder: "Select Item Group", type: "" },
            model: {
              value: _vm.$attrs["v-model"].selectItemGroup,
              callback: function ($$v) {
                _vm.$set(_vm.$attrs["v-model"], "selectItemGroup", $$v)
              },
              expression: "$attrs['v-model'].selectItemGroup",
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        [
          _c("small", [_vm._v("Key")]),
          _c("el-input", {
            attrs: { disabled: _vm.edit, placeholder: "Enter a Key", type: "" },
            model: {
              value: _vm.$attrs["v-model"].key,
              callback: function ($$v) {
                _vm.$set(_vm.$attrs["v-model"], "key", $$v)
              },
              expression: "$attrs['v-model'].key",
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        [
          _c("small", [_vm._v("Capture Value")]),
          _c("el-input", {
            attrs: { placeholder: "Enter Capture Value", type: "" },
            model: {
              value: _vm.$attrs["v-model"].captureValue,
              callback: function ($$v) {
                _vm.$set(_vm.$attrs["v-model"], "captureValue", $$v)
              },
              expression: "$attrs['v-model'].captureValue",
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        [
          _c("small", [_vm._v("PDR Value")]),
          _c("el-input", {
            attrs: { placeholder: "Enter PDR Value", type: "" },
            model: {
              value: _vm.$attrs["v-model"].pdrValue,
              callback: function ($$v) {
                _vm.$set(_vm.$attrs["v-model"], "pdrValue", $$v)
              },
              expression: "$attrs['v-model'].pdrValue",
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        [
          _c("small", [_vm._v("Sort Order")]),
          _c("el-input", {
            attrs: { type: "number", placeholder: "Sort Order" },
            model: {
              value: _vm.$attrs["v-model"].sortOrder,
              callback: function ($$v) {
                _vm.$set(_vm.$attrs["v-model"], "sortOrder", $$v)
              },
              expression: "$attrs['v-model'].sortOrder",
            },
          }),
        ],
        1
      ),
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              _vm.edit
                ? _vm.editItem(_vm.$attrs["v-model"])
                : _vm.addNewSelectItem()
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.edit ? "Update" : "Add") + " Select Item ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }